import { useEffect } from "react";
import Lenis from "lenis";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import "@/App.css";
import Nav from "./components/portfolio/Nav";
import Hero from "./components/portfolio/Hero";
import Marquee from "./components/portfolio/Marquee";
import Projects from "./components/portfolio/Projects";
import Testimonials from "./components/portfolio/Testimonials";
import Services from "./components/portfolio/Services";
import About from "./components/portfolio/About";
import Contact from "./components/portfolio/Contact";
import Footer from "./components/portfolio/Footer";
import PaymentSuccess from "./components/portfolio/PaymentSuccess";
import PaymentCancel from "./components/portfolio/PaymentCancel";

const Portfolio = () => (
  <>
    <Nav />
    <main>
      <Hero />
      <Marquee />
      <Projects />
      <Testimonials />
      <Services />
      <About />
      <Contact />
    </main>
    <Footer />
  </>
);

function App() {
  useEffect(() => {
    document.title = "Merdi — Web Designer | Québec";
    const lenis = new Lenis({ duration: 1.2, smoothWheel: true });
    window.__lenis = lenis;
    let frame;
    const raf = (time) => {
      lenis.raf(time);
      frame = requestAnimationFrame(raf);
    };
    frame = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(frame);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <div className="App bg-[#08080a] text-zinc-100 min-h-screen">
      <div
        className="pointer-events-none fixed inset-0 opacity-[0.03] z-50 mix-blend-overlay bg-[url('https://grainy-gradients.vercel.app/noise.svg')]"
        aria-hidden="true"
      />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Portfolio />} />
          <Route path="/payment/success" element={<PaymentSuccess />} />
          <Route path="/payment/cancel" element={<PaymentCancel />} />
        </Routes>
      </BrowserRouter>
      <Toaster theme="dark" position="bottom-right" richColors />
    </div>
  );
}

export default App;
